export const PORTAL_PERKS = {
  patient: [
    "Расписание и записи",
    "Абонементы и оплаты",
    "PWA-кабинет на телефоне",
  ],
  staff: [
    "Журнал и расписание",
    "Группы и клиенты",
    "Работа с мобильного",
  ],
  admin: [
    "Финансы и аналитика",
    "Залы и абонементы",
    "Команда клуба",
  ],
};

export function unifiedLoginSubtitle(clubName) {
  if (clubName) {
    return `Войдите в кабинет клуба «${clubName}». Подойдёт телефон или email.`;
  }
  return "Войдите в кабинет клуба. Подойдёт телефон или email.";
}

export const UNIFIED_FORGOT_PASSWORD_HINT =
  "Укажите email, который вы используете для входа в этот клуб — сброс доступен только для зарегистрированных аккаунтов.";

export const UNIFIED_FORGOT_PASSWORD_SENT_HINT =
  "Ссылка для сброса пароля отправлена на указанный email.";

export function portalEyebrow(clinicName, portalId) {
  if (clinicName) return `Клуб «${clinicName}»`;
  return "Вход в кабинет";
}
